$(".productgrid--sidebar-section .navmenu li.navmenu-item-parent > a").click(function(e) {
   e.preventDefault()
   $(this).closest('.navmenu-item-parent').find(".navmenu-submenu").toggleClass('show');
});


$('.accordion .toggle').click(function(e) {
  
    var $this = $(this);
  
  	if ($this.hasClass('shown')) {
        $this.removeClass('shown');
    } else {
        $this.parent().parent().find('.toggle').removeClass('shown');
        $this.toggleClass('shown');
    }
  
    if ($this.next().hasClass('shown')) {
        $this.next().removeClass('shown');
        $this.next().slideUp(0);
    } else {
        $this.parent().parent().find('li .inner').removeClass('shown');
        $this.parent().parent().find('li .inner').slideUp(350);
        $this.next().toggleClass('shown');
        $this.next().slideToggle(0);
    }
});